import React, { useContext } from "react";
import { Col, Container, Input, Label, Row } from "reactstrap";
import StepsContext from "../../../context/StepsContext/StepsContext";
import IsShowTitleORNot from "../../../common/isShowTitleORNot";
import { StepTheme } from "../../../constant";
import { ThemeNo } from "../../../../constant";
import { stepStyle1, stepStyle2 } from "./StepsStyleFunction";
import { slugUrlConverter } from "../../../../utils/helper";

const StepsParentPopup = (props) => {
  const { setFormData, fromData, isEdit } = useContext(StepsContext);
  const { simpleValidator } = props;

  /**
   * input value change
   * @param {event} e
   */
  const changeFormValue = (e) => {
    const { value, name, checked } = e.target;
    setFormData((prev) => {
      if (name === "isTitleShow") {
        return {
          ...prev,
          [name]: checked,
        };
      } else if (name === "theme" && value == ThemeNo.ThemeTwo) {
        return {
          ...prev,
          [name]: value,
          style: stepStyle2,
        };
      } else if (name === "theme" && value == ThemeNo.ThemeOne) {
        return {
          ...prev,
          [name]: value,
          style: stepStyle1,
        };
      } else if (name === "title") {
        return {
          ...prev,
          [name]: value,
          slugUrl: slugUrlConverter({ value }),
        };
      } else if (name === "slugUrl") {
        return {
          ...prev,
          [name]: slugUrlConverter({ value }),
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center ">
              <h6>{isEdit ? "Edit" : "Add New"}</h6>
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">
                    Title *{" "}
                    <IsShowTitleORNot
                      checked={fromData?.isTitleShow}
                      onChange={changeFormValue}
                    />{" "}
                  </Label>
                  <Input
                    className="form-control"
                    name="title"
                    type="text"
                    placeholder="Title *"
                    value={fromData?.title}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                  <p style={{ color: "red" }}>
                    {simpleValidator.current.message(
                      "Title",
                      fromData?.title,
                      "required"
                    )}
                  </p>
                </Col>

                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">{"Sub Title"}</Label>
                  <Input
                    className="form-control"
                    name="subTitle"
                    type="text"
                    placeholder="Sub Title"
                    value={fromData?.subTitle}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">{"Theme"}</Label>
                  <select
                    name="theme"
                    id="theme"
                    className="form-select"
                    onChange={(e) => changeFormValue(e)}
                    value={fromData?.theme}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    {StepTheme?.map((elem) => {
                      return (
                        <option value={elem.theme}>{elem?.themeName}</option>
                      );
                    })}
                  </select>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default StepsParentPopup;
